import about01 from '../assets/images/about01.png';
import about02 from '../assets/images/about02.png';
import about03 from '../assets/images/about03.png';
import about04 from '../assets/images/about04.png';
import adidas from '../assets/images/adidas.png';
import amazon from '../assets/images/amazon.png';
import api from '../assets/images/api.png';
import asus from '../assets/images/asus.png';
import bolt from '../assets/images/bolt.png';
import circle from '../assets/images/circle.svg';
import cpp from '../assets/images/cpp.png';
import css from '../assets/images/css.png';
import email from '../assets/images/email.png';
import email1 from '../assets/images/email1.png';
import email2 from '../assets/images/email2.png';
import figma from '../assets/images/figma.png';
import flutter from '../assets/images/flutter.png';
import git from '../assets/images/git.png';
import graphql from '../assets/images/graphql.png';
import html from '../assets/images/html.png';
import javascript from '../assets/images/javascript.png';
import linux from '../assets/images/linux.png';
import logo from '../assets/images/logo.png';
import mobile from '../assets/images/mobile.png';
import mongodb from '../assets/images/database.jpg';
import mu5 from '../assets/images/mu5.png';
import nb from '../assets/images/nb.png';
import nextjs from '../assets/images/nextjs.svg';
import node from '../assets/images/node.png';
import profile from '../assets/images/profile.png';
import python from '../assets/images/python.png';
import react from '../assets/images/react.png';
import redux from '../assets/images/redux.png';
import resume from '../assets/images/resume.png';
import resume1 from '../assets/images/resume1.png';
import resume2 from '../assets/images/resume2.png';
import sass from '../assets/images/sass.png';
import skype from '../assets/images/skype.png';
import spotify from '../assets/images/spotify.png';
import ts from '../assets/images/ts-logo.png';
import typescript from '../assets/images/typescript.png';
import vue from '../assets/images/vue.png';

export default {
  email,
  email1,
  email2,
  mobile,
  resume,
  resume1,
  resume2,
  nextjs,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  mongodb,
  html,
  javascript,
  ts,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logo,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  linux,
};
